import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import { Col, Row } from "react-bootstrap";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  BankFasTdsRec,
  BankFasTdsRecFun,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Bank/BankSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export const TdsReceivable = ({
  tdsName,
  natureOfParty,
  startDate,
  endDate,
}) => {
  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { BankFasTdsRecdata } = useSelector((state) => state.BankSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");
  const YearId = Cookies.get("FinancialYear");

  function formatDateToDDMMYYYY(dateStr) {
    if (!dateStr) return "-";

    const date = new Date(dateStr);

    if (isNaN(date.getTime())) {
      return dateStr;
    }

    return date.toLocaleDateString("en-GB");
  }
  useEffect(() => {
    dispatch(BankFasTdsRecFun());
    dispatch(
      BankFasTdsRec({
        Year: YearId,
        Firm,
        TDSAc: tdsName?.join(",") || "",
        NaturePayment: natureOfParty?.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
  }, [dispatch, tdsName, startDate, endDate]);

  const getRows = BankFasTdsRecdata?.Data?.map((label, index) => ({
    srNumber: index + 1,
    AcName: label.AcName,
    PanNo: label.PanNo,
    TanNo: label.TanNo,
    OwnerName: label.OwnerName,
    TransactionName: label.TransactionName,
    Credit: label.Credit,
  }));

  const getColumns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Party Name",
      key: "AcName",
      colors: isdark === "light" ? "#000" : "#fff",
      align: "left",
    },
    {
      label: "PanNo",
      key: "PanNo",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "TanNo",
      key: "TanNo",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "OwnerName",
      key: "OwnerName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Credit", key: "Credit", align: "right", format: "true" },
  ];

  const getRow1 = BankFasTdsRecdata?.Detail?.map((label, index) => ({
    srNumber: index + 1,
    AcName: label.AcName,
    PanNo: label.PanNo,
    TanNo: label.TanNo,
    OwnerName: label.OwnerName,
    TransactionName: label.TransactionName,
    Credit: label.Credit,
    BillAmt: label.BillAmt,
    BillDate: formatDateToDDMMYYYY(label.BillDate),
    VouDate: formatDateToDDMMYYYY(label.VouDate),
    DocNo: label.DocNo,
    VouNo: label.VouNo,
  }));
  const getColumns2 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Party Name",
      key: "AcName",
      colors: isdark === "light" ? "#000" : "#fff",
      align: "left",
    },
    {
      label: "PanNo",
      key: "PanNo",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "TanNo",
      key: "TanNo",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "OwnerName",
      key: "OwnerName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "TransactionName",
      key: "TransactionName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "VouDate", key: "VouDate", align: "right" },
    { label: "VouNo", key: "VouNo", align: "right" },
    { label: "DocNo", key: "DocNo", align: "right" },

    { label: "Credit", key: "Credit", align: "right", format: "true" },
    { label: "BillDate", key: "BillDate", align: "right", format: "true" },
    { label: "BillAmt", key: "BillAmt", align: "right", format: "true" },
  ];
  if (BankFasTdsRecdata === "no" || BankFasTdsRecdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <Row className="g-4">
      <Col xl={12}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              padding: "14px",
              margin: 0,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              DETAIL
            </h2>
          </div>
          <FASTable data={getRow1} columns={getColumns2} />
        </div>
      </Col>
      <Col xl={12}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              padding: "14px",
              margin: 0,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              SUMMARY
            </h2>
          </div>

          <FASTable data={getRows} columns={getColumns} />
        </div>
      </Col>
    </Row>
  );
};
